import ControlFactory from '@/Factories/ControlFactory';
import * as DateHelper from '@/Utility/DateHelper';
import { FilterInfo } from '#/DefaultViewExtensionInterfaces';
import DatePickerViewModelBase from '@/ViewModels/Controls/DatePickerViewModelBase';

export default class DatePickerFactoryBase extends ControlFactory {
    /**
     * @override
     */
    public viewModel: DatePickerViewModelBase;

    public getValueForFilter(): Object {
        let ret = {};
        ret[this.detailViewItem.name] = this.context.genericObject.getValue(this.detailViewItem.name);

        return ret;
    }

    public getFilterInfo(): FilterInfo {
        return {
            field: this.detailViewItem.name,
            value: DateHelper.toDotNetDateTimeString(this.viewModel?.date()) || '' 
        }
    }
}